import { Box } from '@palmetto/palmetto-components';
import { Link } from 'react-router-dom';

import { HeaderElementProps, Origin } from '../../types/ProductionValueCheck';
import PageHeader from '../PageHeader';
import AdminStipulationBannerList from '../Stipulations/AdminStipulationBannerList';

import { DiffErrorAlert } from './DiffErrorAlert';

export function HeaderElement({
  requestVoid,
  origin,
  accountName,
  errorObject,
  accountId,
  loadingState,
  easyChangeOrder,
  formData,
}: HeaderElementProps) {
  const comesFromInstallMilestone = origin === Origin.INSTALL_PACKAGE;

  return (
    <Box
      as="main"
      gap="md"
      maxWidth="6xl"
      width="100"
      margin="0 auto"
      padding={{
        base: 'md md',
        tablet: '0 0',
      }}
    >
      <AdminStipulationBannerList />
      <PageHeader
        eyebrow={<Link to={`/accounts/${accountId}`}>{accountName}</Link>}
        title={
          comesFromInstallMilestone
            ? 'Confirm Year-1 Total Production'
            : 'Production and System Size Change Order Check'
        }
      />
      {errorObject?.production && requestVoid && !comesFromInstallMilestone ? (
        <DiffErrorAlert
          requestVoid={requestVoid}
          errorObject={errorObject}
          loadingState={loadingState}
          easyChangeOrder={easyChangeOrder}
          accountId={accountId}
          formData={formData}
        />
      ) : null}
    </Box>
  );
}
